import { SelectInput, TextInput } from "react-admin";
import { useWatch } from "react-hook-form";

const taxPostingModeChoices = [
  { id: "MANUAL", name: "MANUAL" },
  { id: "AUTOMATIC", name: "AUTOMATIC" },
];

const customerCodeModeChoices = [
  { id: "LEGACY", name: "LEGACY (CST / CMT / CBT)" },
  { id: "CUS", name: "CUS" },
];

const normalizeValue = (value) => {
  if (typeof value !== "string") {
    return "";
  }

  const trimmed = value.trim();
  if (
    trimmed.startsWith('"') &&
    trimmed.endsWith('"') &&
    trimmed.length >= 2
  ) {
    return trimmed.slice(1, -1);
  }

  return trimmed;
};

export default function SettingValueInput(props) {
  const name = useWatch({ name: "name" });

  if (name === "TAX_POSTING_MODE") {
    return (
      <SelectInput
        {...props}
        source="value"
        choices={taxPostingModeChoices}
        format={normalizeValue}
        parse={(value) => JSON.stringify(value)}
      />
    );
  }

  if (name === "CUSTOMER_CODE_MODE") {
    return (
      <SelectInput
        {...props}
        source="value"
        choices={customerCodeModeChoices}
        format={normalizeValue}
        parse={(value) => JSON.stringify(value)}
      />
    );
  }

  return <TextInput {...props} source="value" />;
}
